import { ServiceInitializer } from '@estee/elc-universal-utils';
import { BaseService } from '@estee/elc-service';

const { name, version } = __serviceInfo__;
export class StoresService extends BaseService {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
    }
}

export default {
    logger: 'LOGGER',
    apiSdk: 'API_SDK',
    inventoryCacheService: 'INVENTORY_CACHE_SERVICE',
    DCInventoryRepository: 'DC_INVENTORY_REPOSITORY',
    DCInventory: 'DC_INVENTORY',
    courierRepository: 'COURIER_REPOSITORY',
    courier: 'COURIER',
    configStore: 'CONFIG_STORE',
    httpTransport: 'HTTP_TRANSPORT',
    storesMapViewController: 'STORES_MAP_VIEW_CONTROLLER',
    storesSidebarViewController: 'STORES_SIDEBAR_VIEW_CONTROLLER',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    bopisStoresSidebarViewController: 'BOPIS_STORES_SIDEBAR_VIEW_CONTROLLER',
    storesListItemActionsViewController: 'STORE_LIST_ITEM_ACTIONS_VIEW_CONTROLLER',
    StoresFiltersViewController: 'STORE_FILTERS_VIEW_CONTROLLER',
    bopisStoresFiltersViewController: 'BOPIS_STORE_FILTERS_VIEW_CONTROLLER',
    storeDetailsViewController: 'STORE_DETAILS_VIEW_CONTROLLER',
    storesDirectoryViewController: 'STORES_DIRECTORY_VIEW_CONTROLLER',
    storesViewController: 'STORES_VIEW_CONTROLLER',
    findInStoreViewController: 'FIND_IN_STORE_VIEW_CONTROLLER',
    findInStoreModalViewController: 'FIND_IN_STORE_MODAL_VIEW_CONTROLLER',
    productViewController: 'PRODUCT_VIEW_CONTROLLER',
    pickUpInStoreViewController: 'PICK_UP_IN_STORE_VIEW_CONTROLLER',
    BOPISInfoModalViewController: 'BOPIS_MODAL_VIEW_CONTROLLER',
    SDDInfoModalViewController: 'SDD_INFO_MODAL_VIEW_CONTROLLER',
    editDeliveryModalViewController: 'EDIT_DELIVERY_MODAL_VIEW_CONTROLLER',
    editDeliveryViewController: 'EDIT_DELIVERY_VIEW_CONTROLLER',
    deliveryMethodsViewController: 'DELIVERY_METHODS_VIEW_CONTROLLER',
    storesMap: 'STORES_MAP',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    numberFormatter: 'NUMBER_FORMATTER',
    urlFormatter: 'URL_FORMATTER',
    businessUnitIdParser: 'BUSSINESS_UNIT_ID_PARSER',
    storesRepository: 'STORES_REPOSITORY',
    storesDirectoryRepository: 'STORES_DIRECTORY_REPOSITORY',
    userLocationRepository: 'USER_LOCATION_REPOSITORY',
    counterRepository: 'COUNTER_REPOSITORY',
    productRepository: 'PRODUCT_REPOSITORY',
    transactionRepository: 'TRANSACTION_REPOSITORY',
    transaction: 'TRANSACTION',
    storesService: 'STORES_SERVICE',
    findInStore: 'FIND_IN_STORE',
    userLocation: 'USER_LOCATION',
    storesHydrateService: 'STORES_HYDRATE_SERVICE',
    BOPISApiSdk: 'BOPIS_API_SDK',
    courierApi: 'COURIER_API',
    DeliveryMethodApiSdk: 'DELIVERY_METHOD_API_SDK',
    transactionApi: 'TRANSACTION_API',
    googleMapsApi: 'GOOGLE_MAPS_API',
    bopisFindStoreModalViewController: 'BOPIS_FIND_STORE_MODAL_VIEW_CONTROLLER',
    searchedLocationRepository: 'SEARCHED_LOCATION_REPOSITORY',
    filtersRepository: 'FILTERS_REPOSITORY',
    bopisFiltersRepository: 'BOPIS_FILTERS_REPOSITORY',
    priceFormatter: 'PRICE_FORMATTER'
};
